// Pure logic extracted from the legacy `line_map.js` Vue 2 options so it can be
// unit-tested and reused by the Vue 3 app. Keep these functions behaviourally
// identical to the original (see the old-vs-new harness in the PR).

export const SORT_KEY_STORAGE = 'line_map_sort_key'
export const SORT_ORDER_STORAGE = 'line_map_sort_order'

const SORT_KEYS = ['display_order', 'created_at', 'distance', 'up']

// The legacy data option validated the persisted key and fell back to
// `display_order`; the order was `asc` only when explicitly stored, otherwise
// `desc`.
export function readSortKey(storage) {
  const key = storage.getItem(SORT_KEY_STORAGE)
  if (key === 'display_order' || key === 'created_at' || key === 'distance' || key === 'up') {
    return key
  } else {
    return 'display_order'
  }
}

export function readSortOrder(storage) {
  return storage.getItem(SORT_ORDER_STORAGE) === 'asc' ? 'asc' : 'desc'
}

export function writeSortKey(storage, key) {
  storage.setItem(SORT_KEY_STORAGE, key)
}

export function writeSortOrder(storage, order) {
  storage.setItem(SORT_ORDER_STORAGE, order)
}

// Comparator from the legacy `sortedRoutes` computed property. Empty values
// always sort last regardless of direction.
export function compareRoutes(a, b, key, desc) {
  const av = a[key]
  const bv = b[key]
  const aEmpty = !(av != null) || av === ''
  const bEmpty = !(bv != null) || bv === ''
  if (aEmpty && bEmpty) return 0
  if (aEmpty) return 1
  if (bEmpty) return -1
  const result =
    key === 'created_at'
      ? Date.parse(av) - Date.parse(bv)
      : key === 'distance' || key === 'up'
        ? Number(av) - Number(bv)
        : String(av).localeCompare(String(bv))
  if (desc) return -result
  return result
}

export function sortRoutes(routes, key, order) {
  const desc = order === 'desc'
  return routes.slice().sort(function (a, b) {
    return compareRoutes(a, b, key, desc)
  })
}

// `displayedRoutes`: trims / lowercases the query and matches the title.
export function filterRoutes(routes, searchQuery) {
  const query = (searchQuery || '').trim().toLowerCase()
  if (query === '') return routes
  return routes.filter(function (route) {
    const title = route.title != null ? String(route.title) : ''
    return title.toLowerCase().indexOf(query) !== -1
  })
}

export function buildSortLabel(sortKeys, sortKey, sortOrder) {
  const item = sortKeys.find(function (i) {
    return i.key === sortKey
  })
  const label = item ? item.label : ''
  const arrow = sortOrder === 'asc' ? '↑' : '↓'
  return `${label} ${arrow}`
}

export function providerName(provider) {
  if (provider === 'RouteLab') {
    return 'ルートラボ'
  } else if (provider === 'bikemap') {
    return 'bikemap'
  } else if (provider === 'rwgps') {
    return 'Ride with GPS'
  } else if (provider === 'file') {
    return 'File'
  }
}

export function providerLink(provider, route_id) {
  if (provider === 'RouteLab') {
    //"https://latlonglab.yahoo.co.jp/route/watch?id=#{route_id}"
    return `/gpx/${route_id}.gpx`
  } else if (provider === 'bikemap') {
    return `https://www.bikemap.net/en/r/${route_id}`
  } else if (provider === 'rwgps') {
    const rid = route_id.match(/\d+/)[0]
    return `https://ridewithgps.com/routes/${rid}`
  } else if (provider === 'file') {
    return `/gpx/${route_id}.gpx`
  }
}

export function checkColor(color) {
  return !!color.match(/^#[0-9a-f]{6}$/)
}

export function convertColorToRgb(color) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color)
  const re = parseInt(result[1], 16)
  const gr = parseInt(result[2], 16)
  const bl = parseInt(result[3], 16)
  return [re, gr, bl]
}
